// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table .cell{padding-left:0;padding-right:0;word-break:break-word;font-size:14px}.el-popover{word-break:break-word;text-align:initial;min-width:0}.table-row-name{font-weight:600}.expanded{background-color:#f5f5f5!important}.allow-new-lines{white-space:pre-line}.label{font-size:15px}.pass{color:#1e971e}.fail,.pass{font-weight:700}.fail{color:red}.push-left{padding-right:2%}.inner-fail{background-color:rgba(255,0,0,.1)!important}.fade,.modal,body{padding-right:0!important}", ""]);
// Exports
module.exports = exports;
